



































































































































































































































































































































































































































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Emit } from "vue-property-decorator";
import { MedicalSpecification } from "@/components/medicalEdit/types";
import OneService from "@/components/medicalEdit/specification/part/OneService.vue";
import ServicePublicMoney from "@/components/medicalEdit/specification/part/ServicePublicMoney.vue";

@Component({
  components: { OneService, ServicePublicMoney }
})
export default class BasicMedical2 extends Vue {
  @Prop() tab!: MedicalSpecification;

  // (18)理学療法士等 2人: basics[28](3日まで) + basics[29](4日以降) を合算表示
  // 単価: 3日まで(basics[28])が0の場合は4日以降(basics[29])の単価を表示（片方のみ算定のケース）
  get p18_2UnitPrice(): number {
    return (this.tab.basics[28].unit_price ?? 0) !== 0
      ? this.tab.basics[28].unit_price
      : (this.tab.basics[29].unit_price ?? 0);
  }
  set p18_2UnitPrice(v: number) {
    this.tab.basics[28].unit_price = v;
  }
  get p18_2Days(): number {
    return (this.tab.basics[28].days ?? 0) + (this.tab.basics[29].days ?? 0);
  }
  set p18_2Days(v: number) {
    this.tab.basics[28].days = v;
    this.tab.basics[29].days = 0;
  }
  get p18_2Total(): number {
    return (
      (this.tab.basics[28].total_money ?? 0) +
      (this.tab.basics[29].total_money ?? 0)
    );
  }
  set p18_2Total(v: number) {
    this.tab.basics[28].total_money = v;
    this.tab.basics[29].total_money = 0;
  }
  get p18_2Pm1(): number {
    return (
      (this.tab.basics[28].public_money1 ?? 0) +
      (this.tab.basics[29].public_money1 ?? 0)
    );
  }
  set p18_2Pm1(v: number) {
    this.tab.basics[28].public_money1 = v;
    this.tab.basics[29].public_money1 = 0;
  }
  get p18_2Pm2(): number {
    return (
      (this.tab.basics[28].public_money2 ?? 0) +
      (this.tab.basics[29].public_money2 ?? 0)
    );
  }
  set p18_2Pm2(v: number) {
    this.tab.basics[28].public_money2 = v;
    this.tab.basics[29].public_money2 = 0;
  }

  // (18)理学療法士等 3人以上: basics[30](3日まで) + basics[31](4日以降) を合算表示
  // 単価: 3日まで(basics[30])が0の場合は4日以降(basics[31])の単価を表示
  get p18_3UnitPrice(): number {
    return (this.tab.basics[30].unit_price ?? 0) !== 0
      ? this.tab.basics[30].unit_price
      : (this.tab.basics[31].unit_price ?? 0);
  }
  set p18_3UnitPrice(v: number) {
    this.tab.basics[30].unit_price = v;
  }
  get p18_3Days(): number {
    return (this.tab.basics[30].days ?? 0) + (this.tab.basics[31].days ?? 0);
  }
  set p18_3Days(v: number) {
    this.tab.basics[30].days = v;
    this.tab.basics[31].days = 0;
  }
  get p18_3Total(): number {
    return (
      (this.tab.basics[30].total_money ?? 0) +
      (this.tab.basics[31].total_money ?? 0)
    );
  }
  set p18_3Total(v: number) {
    this.tab.basics[30].total_money = v;
    this.tab.basics[31].total_money = 0;
  }
  get p18_3Pm1(): number {
    return (
      (this.tab.basics[30].public_money1 ?? 0) +
      (this.tab.basics[31].public_money1 ?? 0)
    );
  }
  set p18_3Pm1(v: number) {
    this.tab.basics[30].public_money1 = v;
    this.tab.basics[31].public_money1 = 0;
  }
  get p18_3Pm2(): number {
    return (
      (this.tab.basics[30].public_money2 ?? 0) +
      (this.tab.basics[31].public_money2 ?? 0)
    );
  }
  set p18_3Pm2(v: number) {
    this.tab.basics[30].public_money2 = v;
    this.tab.basics[31].public_money2 = 0;
  }

  @Emit("changealltotal")
  public changealltotal() {
    return;
  }

  @Emit("changepublicmoney1")
  public changepublicmoney1() {
    return;
  }

  @Emit("changepublicmoney2")
  public changepublicmoney2() {
    return;
  }
}
